<template>
  <div v-if="tabs !== 'login'" class="full-page-background">
    <img
      src="/img/homepage_bg.webp"
      alt="Background"
      class="background-image"
    />
  </div>

  <v-app-bar
    class="admin-app-bar text-white"
    color="#3d80e8"
    shrink-on-scroll
    scroll-target="#scrolling-techniques-3"
  >
    <v-icon class="ml-2 mr-2">mdi-shield-account</v-icon>
    <v-app-bar-title>Admin</v-app-bar-title>
    <v-spacer></v-spacer>
    <span v-if="loggedIn && user.data" class="admin-user-email">{{
      user.data.email
    }}</span>
    <v-btn
      v-if="loggedIn"
      variant="tonal"
      color="white"
      prepend-icon="mdi-logout"
      @click="logOut"
    >
      Logout
    </v-btn>
    <template v-slot:extension>
      <v-tabs align-with-title v-model="tabs" color="#eba614">
        <v-tab value="login" prepend-icon="mdi-login">Login</v-tab>
        <v-tab v-if="loggedIn" value="methods" prepend-icon="mdi-pill"
          >Methods</v-tab
        >
        <v-tab
          v-if="loggedIn"
          value="questions"
          prepend-icon="mdi-help-circle-outline"
          >Questions</v-tab
        >
      </v-tabs>
    </template>
  </v-app-bar>
  <v-window
    v-model="tabs"
    id="scrolling-techniques-3"
    class="overflow-y-auto admin-canvas"
  >
    <v-window-item value="login">
      <login-admin></login-admin>
    </v-window-item>
    <v-window-item v-if="loggedIn" value="methods">
      <method-admin></method-admin>
    </v-window-item>
    <v-window-item v-if="loggedIn" value="questions">
      <question-admin></question-admin>
    </v-window-item>
  </v-window>
</template>

<script>
import LoginAdmin from "./LoginAdmin.vue";
import MethodAdmin from "./MethodAdmin.vue";
import QuestionAdmin from "./QuestionAdmin.vue";
import { mapActions, mapGetters } from "vuex";
import { auth } from "../firebaseConfig.js";
export default {
  name: "AdminDashboard",
  components: { LoginAdmin, MethodAdmin, QuestionAdmin },
  data() {
    return {
      tabs: "login",
    };
  },
  async created() {
    const self = this;
    auth.onAuthStateChanged((user) => {
      self.fetchUser(user);
    });
  },
  computed: {
    ...mapGetters(["user", "loggedIn"]),
  },
  methods: {
    ...mapActions(["logIn", "logOut", "fetchUser"]),
  },
};
</script>

<style scoped>
/* Admin page specific overrides to prevent global styles from interfering */
:deep(.v-main) {
  height: auto !important;
  overflow: visible !important;
}

:deep(.v-application) {
  overflow: visible !important;
}

.full-page-background {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 0;
}

.background-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center 30%;
}

:deep(.admin-app-bar) {
  background-image: linear-gradient(
    135deg,
    #3d80e8 0%,
    #5a9de0 100%
  ) !important;
}

:deep(.admin-app-bar .v-toolbar-title__placeholder) {
  font-family: "Montserrat", sans-serif;
  font-weight: 700;
  letter-spacing: 0.04em;
}

.admin-user-email {
  color: rgba(255, 255, 255, 0.85);
  font-size: 0.85rem;
  margin-right: 12px;
  max-width: 160px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  @media (max-width: 480px) {
    display: none;
  }
}

#scrolling-techniques-3 {
  position: relative;
  z-index: 1;
  margin-top: 0;
  padding-top: 120px; /* Account for app bar height */
  height: 100%;
  overflow-y: auto;
  background: transparent;
}

/* Ensure window items have proper spacing and stay readable on wide screens */
:deep(.v-window-item) {
  padding: 20px;
  max-width: 1280px;
  margin: 0 auto;
}

/* Override any global page container styles for admin */
:deep(.page-container) {
  height: auto !important;
  background: transparent !important;
}
</style>
